<div class="switcher">
  <div
    class="switcher_element"
    *ngFor="let option of options"
    (click)="selectedOption = option"
    [ngClass]="{
      'switcher_element--active':
        (option.value === selectedOption && selectedOption.value) ||
        option === selectedOption
    }"
  >
    {{ option.display || option }}
  </div>
</div>
